export default __webpack_public_path__ + "static/media/competition-card-img-2.1921dac6.png";